export default function getNextBusinessDay(numberOfDays = 0, startDate) {
    startDate = startDate ? new Date(startDate) : new Date();
    startDate = new Date(startDate.getTime());
    const day = startDate.getDay();
    /* istanbul ignore next */
    const nextBusinessDay = startDate.setDate(
        startDate.getDate() +
            numberOfDays +
            (day === 6 ? 2 : +!day) +
            Math.floor((numberOfDays - 1 + (day % 6 || 1)) / 5) * 2
    );
    return new Date(nextBusinessDay);
}
